import { render, staticRenderFns } from "./CourseDocumentInfoCreate.vue?vue&type=template&id=09fd5704&"
import script from "./CourseDocumentInfoCreate.vue?vue&type=script&lang=ts&"
export * from "./CourseDocumentInfoCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports